// extracted by mini-css-extract-plugin
export default {"notfound":"pagenotfound_notfound__blYWX","btn":"pagenotfound_btn__musBO","custome_row":"pagenotfound_custome_row__oASVP"};